if($('.type-detail').length){
        function findPLUByCode(code, pluData) {
            let foundItem = pluData.find(item => item.code === code);
            return foundItem ? foundItem.plu : null;
        }
        function processElements(pluData) {
            setTimeout(function(){
                $(".col-xs-12:not(.col-lg-6) .p-code > span").not(".p-code-label").not(".no-display").each(function() {
                    let code = $(this).text().trim();
                    let plu = findPLUByCode(code, pluData);
                    $('.supplierBox').remove()
                    if (plu) {
                        if(!$('.variant-list').length){
                            if(!$('.supplierBox').length){
                                $('.availability-value').after('<div class="supplierBox">Skladem u dodavatele '+plu+' ks</div>')
                            }
                        }
                        else{
                            $('.supplierBox').remove()
                            if(!$('.supplierBox').length){
                                $('.availability-value').after('<div class="supplierBox">Skladem u dodavatele '+plu+' ks</div>')
                            }
                        }
                    }
                });
            }, 250)
            
        }
        let storedData = sessionStorage.getItem("pluData");
        if (storedData) {
            let pluData = JSON.parse(storedData);
            $(document).ready(function() {
                processElements(pluData);
            })
            document.addEventListener('ShoptetSplitVariantParameterChange', function() {
                processElements(pluData);
           
            });
        } else {
            $.getJSON("/user/documents/plu.json?v"+new Date().getMinutes(), function(data) {
                sessionStorage.setItem("pluData", JSON.stringify(data));
                $(document).ready(function() {
                    processElements(data);
                })
                document.addEventListener('ShoptetSplitVariantParameterChange', function() {
                    processElements(data);
                });
            });
        }
    
    
}